export class NewDegree {
    id: any = null;
    order: Number = null;
    category: any = '';
    degreeName: String = '';
    alternateName: any = [];
    fullName: String = '';
    enableFieldOfStudy: boolean = false;
    showInParenthesis: boolean = false;
}